module.exports = __webpack_public_path__ + "media/application/images/svgs/alert-triangle-c7447a0f25006848b10d59502dae5838.svg";